export default function convertTimeToReadable(time) {
  const timeArr = time.split(":");
  const timeInt = parseInt(timeArr[0], 10);
  const amPm = timeInt > 11 ? "PM" : "AM";
  const first = timeInt > 12 ? timeInt - 12 : timeInt;

  return `${first}:${timeArr[1]} ${amPm}`;
}



// WEBPACK FOOTER //
// ./src/utilities/convertTimeToReadable.js